import * as GBConst from "./GBConst";

export const clone = (data) => {
    if (typeof data === "undefined") {
        return undefined;
    } else {
        return JSON.parse(JSON.stringify(data));
    }
};

export const createArray = (dim, bounds, defaultVal = "", _arr = undefined) => {
    if (typeof _arr === "undefined") {
        _arr = [];
    }

    let len = bounds.slice().reverse()[dim - 1];

    if (dim > 1) {
        for (let i = 0; i < len; i++) {
            _arr[i] = createArray(dim - 1, bounds, defaultVal, _arr[i]);
        }
        return _arr;
    } else {
        for (let i = 0; i < len; i++) {
            _arr[i] = clone(defaultVal);
        }
        return _arr;
    }

    //---------------------------------------------------------------------------------------------------
    // Passing tests
    //
    // let a = createArray(1, [3], "test");               a[0] = "different"; console.log(a);
    // let b = createArray(1, [3], {test: "test"});       b[0].test = "different"; console.log(b);

    // let c = createArray(2, [3, 3], "test");            c[0][0] = "different"; console.log(c);
    // let d = createArray(2, [3, 3], {test: "test"});    d[0][0].test = "different"; console.log(d);

    // let e = createArray(2, [5, 6], "test");            e[0][0] = "different"; console.log(e);
    // let f = createArray(2, [5, 6], {test: "test"});    f[0][0].test = "different"; console.log(f);

    // let g = createArray(3, [1, 2, 3], "test");         g[0][0][0] = "different"; console.log(g);
    // let h = createArray(3, [1, 2, 3], {test: "test"}); h[0][0][0].test = "different"; console.log(h);

    // let g = createArray(10, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], "test"); console.log(g);
    //---------------------------------------------------------------------------------------------------

    //---------------------------------------------------------------------------------------------------
    // Notes
    //
    // TGP: Bad! Elements by reference
    //     return Array(length).fill(clone(value));
    //
    // TGP : Bad!  Elements by reference
    //     let len = bounds.shift();
    //
    //     if (dim > 1) {
    //         return Array.from({length: len}, x => createArray(dim - 1, clone(bounds), value));
    //     } else {
    //         return Array(len).fill(value);
    //     }
    //---------------------------------------------------------------------------------------------------
};

export const createVector = (length, defaultVal = 0) => {
    return createArray(1, [length], defaultVal);

    // let arr = [];

    // for (let r = 0; r < length; r++) {
    //     arr[r] = clone(defaultVal);
    // }

    // return arr;

    //--------------------------------------------------------------------------------------
    // Passing tests
    //
    // let a = createVector(2, { intArray: [] }); a[0].intArray = [2]; console.log(a);
    //--------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------
    // Notes
    //
    // TGP: Bad! Elements by reference
    // return Array(length).fill(clone(value));
    //--------------------------------------------------------------------------------------
};

export const createMatrix = (rowCount, columnCount, defaultVal = 0) => {
    return createArray(2, [rowCount, columnCount], defaultVal);

    // let arr = [];

    // for (let r = 0; r < rowCount; r++) {
    //     arr[r] = [];
    //     for (let c = 0; c < columnCount; c++) {
    //         arr[r][c] = clone(defaultVal);
    //     }
    // }

    // return arr;

    //--------------------------------------------------------------------------------------
    // Passing tests
    //
    // let a = createMatrix(2, 2, { intArray: [] }); a[0][0].intArray = [2]; console.log(a);
    //--------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------
    // Notes
    //
    // TGP: Bad! Elements by reference
    // return Array.from({length: rowCount}, x => Array(columnCount).fill(clone(value)));
    //
    // TGP: Bad! Elements by reference
    // return Array(rowCount).fill(Array(columnCount).fill(value));
    //--------------------------------------------------------------------------------------
};

export function getModName(modMstIDByte, DMVersion = GBConst.GB_DM_Banner) {
    let modNameStr = "";

    switch (modMstIDByte) {
        case GBConst.GB_SC:
            modNameStr = "VMMC Site Capacity and Productivity Assessment Tool (legacy)";
            break;

        case GBConst.GB_DM:
            switch (DMVersion) {
                case GBConst.GB_DM_Banner:
                    modNameStr = "VMMC Decision-Makers' Program Planning Toolkit 2";
                    break;

                case GBConst.GB_3MC_2025:
                    modNameStr = "DMPPT 2 / threeMC (2025)*";
                    break;

                case GBConst.GB_Original_2025:
                    modNameStr = "DMPPT 2 (2025)*";
                    break;

                case GBConst.GB_3MC_2024:
                    modNameStr = "DMPPT 2 / threeMC (2024)*";
                    break;

                case GBConst.GB_Original_2024:
                    modNameStr = "DMPPT 2 (2024)*";
                    break;

                case GBConst.GB_3MC_2023:
                    modNameStr = "DMPPT 2 / threeMC (2023)";
                    break;

                case GBConst.GB_Original_2023:
                    modNameStr = "DMPPT 2 (2023)";
                    break;

                default:
                    modNameStr = "";
            }
            break;

        case GBConst.GB_GB:
            modNameStr = "VMMC Implementation Planning Toolkit";
            break;

        default:
            modNameStr = "";
    }

    return modNameStr;
}

export function getModAbbr(modMstIDByte) {
    let modNameStr = "";

    switch (modMstIDByte) {
        case GBConst.GB_SC:
            modNameStr = "SCPT";
            break;

        case GBConst.GB_DM:
            modNameStr = "DMPPT 2";
            break;

        case GBConst.GB_GB:
            modNameStr = "VIPT";
            break;

        default:
            modNameStr = "";
    }

    return modNameStr;
}

/* WARNING: Does not seem to work; values assigned to the array get copied over all the dimensions! */
// export const createArray = (n, bounds, value) => {
//
//     let len = bounds[0];
//     bounds.shift();
//
//     if (n > 1) {
//         return Array(len).fill( createArray(n-1, bounds, value) );
//     }
//     else {
//         return Array(len).fill( value );
//     }
// }

export function equal(object1, object2) {
    for (var property in object1) {
        if (!object2.hasOwnProperty(property)) {
            return false;
        }
    }

    return true;
}

export function getDelphiColorToHex(color) {
    if (color >= 0) {
        let hexString = color.toString(16);
        hexString = hexString.padStart(6, 0);

        let R = hexString.slice(-2);
        let G = hexString.slice(-4, -2);
        let B = hexString.slice(-6, -4);

        return "#" + (R + G + B);
    } else {
        return "";
    }
}

// not tested
export function getHexFromDelphiHexColor(hexStr) {
    let RGB;

    let R = hexStr.substr(5, 2);
    let G = hexStr.substr(3, 2);
    let B = hexStr.substr(1, 2);

    RGB = "#" + R + G + B;

    return RGB;
}

// not tested
export function getDelphiHexFromHexColor(hexStr) {
    let BGR;

    let R = hexStr.substr(1, 2);
    let G = hexStr.substr(3, 2);
    let B = hexStr.substr(5, 2);

    BGR = "#" + B + G + R;

    return BGR;
}

/* Converts a number in one base to base 10.  If the base is not specified, the base will be 16 (hex).
   Currently works up to base 16. */
export function toBase10(baseXStr, baseFrom) {
    let numBase10 = 0;

    if (typeof baseFrom === "undefined") {
        baseFrom = 16;
    }

    /* Remove #, if it exists. */
    let baseXStrNoHash = baseXStr.replace("#", "");

    /* Pos = position of current character in number, with the rightmost position being 0. */
    let pos = baseXStrNoHash.length - 1;
    let exp = 0;

    if (pos > -1) {
        while (pos !== -1) {
            /* Get the current character. */
            let n = baseXStrNoHash.substr(pos, 1);
            const nAsInt = parseInt(n);

            /* Convert n to a number if it's a letter. */
            if (isNaN(nAsInt)) {
                switch (n.toUpperCase()) {
                    case "A":
                        n = 10;
                        break;
                    case "B":
                        n = 11;
                        break;
                    case "C":
                        n = 12;
                        break;
                    case "D":
                        n = 13;
                        break;
                    case "E":
                        n = 14;
                        break;
                    case "F":
                        n = 15;
                        break;
                    default:
                        n = 1;
                        break;
                }
            }

            numBase10 += n * Math.pow(baseFrom, exp);

            pos--;
            exp++;
        }
    }

    return numBase10;
}

// scary, but existed before, so continues to exist
export function division(dividend, divisor) {
    let quotient = dividend / divisor;

    if (!isFinite(quotient)) {
        //alert('Error: Division by zero.');
        return 0; // Can be changed to whatever is desired by the programmer to be 0, false, or Infinity
    } else {
        return quotient; //Will return Infinity or -Infinity in cases of, for example, 5/0 or -7/0 respectively
    }
}

export function shouldComponentUpdateGB(currProps, nextProps, currState, nextState) {
    const nextPropsStr = JSON.stringify(nextProps);
    const currPropsStr = JSON.stringify(currProps);

    return nextPropsStr !== currPropsStr || nextState !== currState;
}

export const cloneObj = (obj) => {
    return JSON.parse(JSON.stringify(obj));
};
